<template>
  <div id="app" :style="cssProps">
    <div :class="{'overlay':overlay }"></div>
    <router-view/>
  </div>
</template>
<script>
// import { USER_REQUEST } from '@/store/actions/user'
import { mapState } from 'vuex';

export default {
  name: 'App',
  data () {
    return {
      isActive: false,
      windowWidth: 0,
      windowHeight: 0
    };
  },
  // created: function () {
  //   if (this.$store.getters.isAuthenticated) {
  //     this.$store.dispatch(USER_REQUEST)
  //   }
  // },
  watch: {
    windowWidth () {
      this.storeWindowWidth(this.windowWidth);
      // if (this.windowWidth < 750) {
      //   this.isActive = true
      // } else {
      //   this.isActive = false
      // }
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth);
      window.addEventListener('resize', this.getWindowHeight);

      // Init
      this.getWindowWidth();
      this.getWindowHeight();
      this.setPrimaryColor();
      this.setSecondaryColor();
      this.setApiPage();
    });
  },
  methods: {
    setApiPage () {
      this.$store.state.data.ApiPage = true;
    },
    getWindowWidth () {
      this.windowWidth = document.documentElement.clientWidth;
    },
    getWindowHeight () {
      this.windowHeight = document.documentElement.clientHeight;
    },
    storeWindowWidth (key) {
      this.$store.state.window.size = key;
    },
    setPrimaryColor () {
      this.$store.dispatch('setPrimaryColor', '#1e2a5f');
    },
    setSecondaryColor () {
      this.$store.dispatch('setSecondaryColor', '#0676ee');
    },
    generateColor () {
      // Generate Random Hex Color
      let length = 6;
      const chars = '0123456789ABCDEF';
      let hex = '#';
      while (length--) hex += chars[(Math.random() * 16) | 0];
      return hex;
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getWindowWidth);
    window.removeEventListener('resize', this.getWindowHeight);
  },

  computed: {
    ...mapState('menu', {
      overlay: state => state.overlay
    }),
    ...mapState({
      primaryColor: state => state.app.primaryColor
    }),
    ...mapState({
      secondaryColor: state => state.app.secondaryColor
    }),
    cssProps () {
      return {
        '--main-color': this.primaryColor,
        '--secondary-color': this.secondaryColor
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue